import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextField from "@material-ui/core/TextField";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { IconButton } from '@material-ui/core';

export function isNullOrEmpty(str) {
    return (!str || 0 === str.length);
}

export function isPassword(password) {
    let pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{8,}$/;
    return pattern.test(password);
}

const Adornment = ({ state, onClick }) => (
    <IconButton
        size="small"
        onClick={onClick}
    >
        {state ? <VisibilityOff /> : <Visibility />}
    </IconButton>
);

Adornment.propTypes = {
    state: PropTypes.bool,
    onClick: PropTypes.func
};

const wrongPasswordText = "Hasło nie spełnia wymagań";

const PasswordInput = props => {
    const { onBlur, onBadPassword, noValidation, onChange, ...restProps } = props;
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [badPassword, setBadPassword] = useState(null);

    useEffect(() => {
        if(onBadPassword)
            badPassword !== null ? onBadPassword(true) : onBadPassword(false);
    }, [badPassword]);

    const handleBlur = (e) => {
        if(noValidation)
            return onBlur && onBlur(e.target.value);
        if (!isPassword(e.target.value) && !isNullOrEmpty(e.target.value))
            setBadPassword(wrongPasswordText);
        else {
            setBadPassword(null);
            onBlur && onBlur(e.target.value);
        }
    };

    const handleChange = e => {
        if(noValidation)
            onChange && onChange(e);
        else if(isPassword(e.target.value))
            setBadPassword(null);
    };

    return (
        <>
            <TextField
                type={passwordVisible ? "text" : "password"}
                InputProps={{
                    endAdornment: <Adornment state={passwordVisible} onClick={() => setPasswordVisible(!passwordVisible)} />
                }}
                onChange={handleChange}
                onBlur={handleBlur}
                error={badPassword !== null}
                helperText={badPassword}
                {...restProps}
            />
        </>
    );
};

PasswordInput.propTypes = {
    noValidation: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onBadPassword: PropTypes.func
};

export default PasswordInput;
